import axios from "axios";
import Swal from "sweetalert2";
import config from "./config.json";

async function handleRequest(url) {
  if (url.includes("192.168.1.101")) {
    try {
      await axios.get(url);
    } catch (e) {
      return;
    }
  } else {
    const res = await axios.get(`${config.path.ecois}${url}`, {
      headers: { Authorization: localStorage.getItem("ecois_token") },
    });
    if (res.status === 200) {
      return res.data;
    } else {
      throw new Error(res.statusText);
    }
  }
}

const ecoisAPI = {
  login: () => {
    const appid = process.env.REACT_APP_ECOIS_API_APPID;
    const appsecret = process.env.REACT_APP_ECOIS_API_APPSECRET.replaceAll("@", "$");
    return handleRequest(`/token?appid=${appid}&secret=${appsecret}`);
  },
  openWaterValve: () => {
    return handleRequest(`${config.path.arduino}/gpio/1`);
  },
  closeWaterValve: () => {
    return handleRequest(`${config.path.arduino}/gpio/0`);
  },
  getDeviceList: () => {
    return handleRequest("/devices?page=1&limit=50");
  },
  getDeviceDetails: ({ sn }) => {
    return handleRequest(`/device/${sn}`);
  },
  getDeviceDescription: ({ sn }) => {
    return handleRequest(`/device/${sn}/description`);
  },
  getSensorValueByTimeRangeAndTypes: ({ sn, from, to, types }) => {
    return handleRequest(
      `/device/${sn}/data?range=${from},${to}&includeParameters=${types.join(",")}`,
    );
  },
  getSensorValueListLatest: ({ sn }) => {
    return handleRequest(`/device/${sn}/latest`);
  },
  getSensorValueListByTimestamp: ({ sn, time }) => {
    return handleRequest(`/device/${sn}/data/moment/${time}`);
  },
};

export default ecoisAPI;

export function handleError(error) {
  Swal.fire(
    "錯誤",
    `<div style='flex flex-start'>錯誤信息: ${JSON.stringify(error)}</div>`,
    "error",
  );
}
